import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { ImageWithFallback } from './ImageWithFallback';
import './BannerAd.css';

export function BannerAd({ position = 'bottom', dismissible = true, isPremiumUser = false }) {
  const [isVisible, setIsVisible] = useState(true);

  // Don't show ads for premium users
  if (isPremiumUser) return null;

  // Mock ad data - in real app this would come from ad network
  const adContent = {
    image: 'https://images.unsplash.com/photo-1567552379232-c32f3d41d353?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwcmVzdGF1cmFudCUyMHdpbmV8ZW58MXx8fHwxNzY0MDk4NjY0fDA&ixlib=rb-4.1.0&q=80&w=1080',
    title: 'Discover Fine Wines',
    subtitle: 'Premium wine pairings for every meal',
    cta: 'Explore Now',
    link: '#',
  };

  if (!isVisible) return null;

  const baseClasses = position === 'inline' 
    ? 'my-8' 
    : 'fixed left-0 right-0 z-30';
  
  const positionClasses = position === 'top' ? 'top-0' : position === 'bottom' ? 'bottom-0' : '';

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: position === 'top' ? -20 : position === 'bottom' ? 20 : 0 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: position === 'top' ? -20 : position === 'bottom' ? 20 : 0 }}
          className={`${baseClasses} ${positionClasses} bg-stone-100 border-y border-border`}
        >
          <div className="max-w-7xl mx-auto px-8">
            <div className="flex items-center justify-between gap-6 py-3">
              {/* Ad Label */}
              <div className="flex items-center gap-4">
                <span className="text-xs uppercase tracking-widest text-muted-foreground whitespace-nowrap">
                  Advertisement
                </span>
                <div className="w-px h-4 bg-border"></div>
              </div>

              {/* Ad Content */}
              <a 
                href={adContent.link}
                className="flex items-center gap-6 flex-1 group"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="w-16 h-16 overflow-hidden flex-shrink-0">
                  <ImageWithFallback
                    src={adContent.image}
                    alt={adContent.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm mb-0.5 group-hover:text-muted-foreground transition-colors truncate">
                    {adContent.title}
                  </p>
                  <p className="text-xs text-muted-foreground truncate">
                    {adContent.subtitle}
                  </p>
                </div>
                <div className="px-6 py-2 border border-border group-hover:border-foreground transition-colors text-xs uppercase tracking-widest whitespace-nowrap">
                  {adContent.cta}
                </div>
              </a>

              {/* Dismiss Button */}
              {dismissible && (
                <button
                  onClick={() => setIsVisible(false)}
                  className="w-8 h-8 border border-border hover:border-foreground flex items-center justify-center transition-colors flex-shrink-0"
                  aria-label="Close advertisement"
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

